import { Add, Search } from '@mui/icons-material';
import {
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { Placeholder, SortableTableHeader, Subheader } from 'components';
import CostItem from './CostItem';
import { useNavigation } from 'hooks';
import useCostItems from 'hooks/useCostItems';
import { useEffect } from 'react';

const TABLE_HEADERS = [
	{
		value: 'name',
		label: 'Name',
		sortable: false,
		hidden: false
	},

	{
		value: 'item',
		label: 'Type',
		sortable: false,
		hidden: false
	},
	{
		value: 'cost',
		label: 'Coins',
		sortable: false,
		hidden: false
	}
];

const CostItemsList = () => {
	const { findCostItems, costItems, isLoading } = useCostItems();

	const { handleClick, handleEditClick, handleAddClick } = useNavigation({
		history,
		url: '/cost-items'
	});

	const handleDeleteClick = (costItem) => {};

	useEffect(() => {
		findCostItems();
	}, []);

	return (
		<>
			<Subheader title="Cost Items" buttons={[]} />

			<Container maxWidth="lg">
				{!isLoading && costItems.length > 0 ? (
					<TableContainer component={Paper} elevation={0}>
						<Table>
							<TableHead>
								<TableRow>
									{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
										<SortableTableHeader
											key={idx}
											handleSort={() => {}}
											value={`cost-items.${header.value}`}
											sortable={header.sortable}
											sortKey={''}
											sortDirection={''}
										>
											{header.label}
										</SortableTableHeader>
									))}
									<TableCell></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{costItems.map((costItem, idx) => (
									<CostItem
										key={idx}
										costItem={costItem}
										handleClick={handleClick}
										handleDeleteClick={handleDeleteClick}
										handleEditClick={handleEditClick}
									/>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				) : (
					<Placeholder
						icon={<Search />}
						title="No Cost Items"
						subtitle="Please try again"
					/>
				)}
			</Container>
		</>
	);
};

export default CostItemsList;
